import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({

  FilterChip: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&.has-color': {
        display: 'flex'
      }
    }
  },
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& *': {
      maxWidth: 225,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  modifyLink: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0),
    transition: 'all 0.3s ease-in-out',
    backgroundColor: 'transparent !important',
    fontWeight: theme.typography.fontWeightSemiBold,
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },
  editBtn: {
    marginTop: theme.spacing(-1.5),
    marginBottom: theme.spacing(-1.5)
  },
  status: {
    '&.active': {
      color: theme.palette.success.main
    },
    '&.not-active': {
      color: theme.palette.error.main
    }
  },
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    marginLeft: theme.spacing(0.375),
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.approved': {
      color: theme.palette.success.main
    },
    '&.rejected': {
      color: theme.palette.error.main
    },
    '&.submitted': {
      color: theme.palette.info.light
    }

  },
  BulkActionsWrapper: {
    // display: 'inline-block',
    position: 'sticky',
    zIndex: 1060,
    bottom: theme.spacing(0),
    left: theme.spacing(3),
    width: '100%',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  BulkActionsCountWrapper: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '& .MuiButtonGroup-vertical': {
        marginTop: theme.spacing(1),
        flex: '1 1 auto'
      }
    }
  },
  BulkActionsMessage: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: 1.6,
    alignItems: 'flex-start',
    flexDirection: 'column',
    '& p': {
      marginTop: 0,
      marginBottom: theme.spacing(0)
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(14)
    }
  },
  bulkClearBtn: {
    marginLeft: theme.spacing(2)
  },
  invoiceTemplateCreate: {
    marginRight: theme.spacing(3)
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}))
